

import Vue from 'vue'
import App from '../../App'
import router from './router.js'

import axios from 'axios' 





import MetaInfo from 'vue-meta-info';

Vue.use(MetaInfo)

import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'


Vue.use(AlertPlugin)
Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)

/***
* 图片懒加载插件
*/
import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad, {
preLoad: 1.3, //预加载高度
error: require("@/assets/image/icon/img_lazyload.png"),
loading: require("@/assets/image/icon/img_lazyload.png"),
attempt: 1
})

import ccRequest from "../../utils/request.js";
Vue.prototype.CCrequest = ccRequest

import ccUtils from "../../utils/utils.js";
Vue.prototype.ccUtils = ccUtils

Vue.prototype.OPENAPP = function () {

if (/android/i.test(navigator.userAgent)) {

if (/MicroMessenger/i.test(navigator.userAgent)) {
alert("微信内置浏览器不支持打开本地应用,请点击右上角使用本地浏览器打开"); 

return
}
}

if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {

if (/MicroMessenger/i.test(navigator.userAgent)) {
alert(
"微信内置浏览器不支持打开本地应用,请点击右上角使用本地浏览器打开"
); //这是微信平台下浏览器
return
}
}


if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
window.location.href = "nowbook://"; 
window.setTimeout(function () {
window.location.href = "itms-apps://itunes.apple.com/cn/app/id1446373183";
}, 2000);
}
if (navigator.userAgent.match(/android/i)) {
window.location.href = "nowbook://app"; 
window.setTimeout(function () {

window.location.href = 'http://nowbook.hk/#/download';
}, 2000);
}

}


import {
CONFIG,
SERVER
} from "@/api/apiConfig.js";
Vue.prototype.CONFIG = CONFIG
Vue.prototype.SERVER = SERVER




Vue.config.productionTip = false


function viewh() {
window.onload = function () {
console.log(document.body.scrollHeight, document.body.clientHeight);
}
}
viewh()

document.documentElement.addEventListener('touchmove', function (event) {
event.preventDefault();
if (event.touches.length > 1) {}
}, false);
/* eslint-disable no-new */
var vm = new Vue({
el: '#app',
router,
components: {
App
},
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/page/secrecy/index.js